//noScroll
class NavToggle {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {

    let options = {
      threshold: [0],
      rootMargin: '-49.9%',
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio > 0){
          $(`.js-nav-target [href="#${$(item).attr('id')}"]`).parent().siblings().removeClass('is-active')
          $(`.js-nav-target [href="#${$(item).attr('id')}"]`).parent().addClass('is-active')
        } else {
          $(`.js-nav-target [href="#${$(item).attr('id')}"]`).parent().removeClass('is-active')
        }
      })
    }, options)

    const anchorEl = document.querySelectorAll('[id*="anchor"]')
    anchorEl.forEach((e)=>{
      observerEnter.observe(e)
    })

    $(".js-nav-target a").click(function() {
      setTimeout(() => {
        $(this).siblings().removeClass('is-active')
        $(this).addClass('is-active')
      }, 600)
    })
  }
}